@if (showPage) {
<div class="d-flex justify-content-center align-items-center min-vh-100 bg-light">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-10 col-sm-12 text-center widget-border p-4">
        <div class="mb-4">
          <div><i class="bi bi-check2-circle display-1 text-primary"></i></div>
        </div>
        <h2 class="fw-bold mb-3 font-size-xxl">Congratulations</h2>
        <hr class="divider-display my-4">
        <p>Your account has been activated successfully.</p>
        <p>You can now sign in to your account.</p>
        <div class="mt-4">
          <button class="btn btn-primary" routerLink="/signin">Sign in</button>
        </div>
      </div>
    </div>
  </div>
</div>
}